import { Component } from "react";
import onClickOutside from "react-onclickoutside";
class ClickOutsideToggle extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            isOpened: false,
        };
        this.handleClickOutside = () => this.props.closeOnClickOutside && this.setState({ isOpened: false });
        this.handleChange = (isOpened) => this.setState({ isOpened });
    }
    render() {
        const { isOpened } = this.state;
        const { outsideClickIgnoreClass } = this.props;
        return this.props.children({
            isOpened,
            setIsOpened: this.handleChange,
            outsideClickIgnoreClass,
        });
    }
}
ClickOutsideToggle.defaultProps = {
    closeOnClickOutside: true,
};
export const Toggle = onClickOutside(ClickOutsideToggle, {
    excludeScrollbar: true,
});
